import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledIngredientCard,
  IngredientImage,
  IngredientCardBody,
  InfoContainer,
  Headline,
  Image,
} from './styles.js';

export const IngredientCard = ({ image, name, children }) => {
  return (
    <StyledIngredientCard>
      <IngredientImage>
        <Image src={image.src} alt={image.alt} />
      </IngredientImage>
      <InfoContainer>
        <Headline>{name}</Headline>
        <IngredientCardBody>{children}</IngredientCardBody>
      </InfoContainer>
    </StyledIngredientCard>
  );
};

IngredientCard.displayName = 'IngredientCard';

IngredientCard.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
  }),
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
